export enum EUnlockMode {
	loginPassword = "loginPassword",
	fingerprint = "fingerprint",
	pin = "pin"
}